<template>
	<v-row class="pa-5" v-if="exercise">
		<v-col cols="12">
			<h2>Priorities Summary</h2>
		</v-col>
		<v-col cols="10" offset="1">
			<v-row>
				<v-col cols="6">
					<v-card light color="light-green accent-2">
						<v-card-text>
							<results-items
								v-model="flatten.q1"
								name="matrix.q1"
								title="Quick Wins"
								subtitle="High impact, Low effort"
							></results-items>
						</v-card-text>
					</v-card>
				</v-col>
				<v-col cols="6">
					<v-card light color="orange lighten-1">
						<v-card-text>
							<results-items
								v-model="flatten.q2"
								name="matrix.q2"
								title="Priority 2"
								subtitle="High impact, High effort"
							></results-items> </v-card-text
					></v-card>
				</v-col>
				<v-col cols="6">
					<v-card light color="yellow lighten-1">
						<v-card-text>
							<results-items
								v-model="flatten.q3"
								name="matrix.q3"
								title="Priority 1"
								subtitle="Low impact, Low effort"
							></results-items> </v-card-text
					></v-card>
				</v-col>
				<v-col cols="6">
					<v-card light color="deep-orange lighten-1">
						<v-card-text>
							<results-items
								v-model="flatten.q4"
								name="matrix.q4"
								title="Nice to have"
								subtitle="Low impact, High effort"
							></results-items> </v-card-text
					></v-card>
				</v-col>
			</v-row>
		</v-col>
	</v-row>
</template>

<script>
// import lodash from "lodash";
const fb = require('@/firebaseConfig.js');
import { mapState } from 'vuex';
import ResultsItems from './ResultsItems';

export default {
	name: 'ResultsSummaryPriority',
	data() {
		return {
			doc: null,
			exercise: null,
			results: {
				q1: [],
				q2: [],
				q3: [],
				q4: [],
			},
			flatten: {
				q1: [],
				q2: [],
				q3: [],
				q4: [],
			},
			dialog: false,
		};
	},
	props: {
		uid: String,
		id: String,
	},

	components: {
		ResultsItems,
	},
	mounted() {
		this.getExercise();
	},
	computed: {
		...mapState([
			'userProfile',
			'currentUser',
			'currentProject',
			'currentProjectModel',
		]),
	},
	methods: {
		getExercise() {
			console.log('get exercise summary');
			let ref = fb.priorityExCollection.where('pid', '==', this.id);
			ref.onSnapshot((querySnapshot) => {
				querySnapshot.forEach((docs) => {
					let post = docs.data();
					this.getResults(post.doc);
				});
				this.exercise = true;
			});
		},
		getResults(doc) {
			this.pushToArray(doc.matrix.q1, 'q1');
			this.pushToArray(doc.matrix.q2, 'q2');
			this.pushToArray(doc.matrix.q3, 'q3');
			this.pushToArray(doc.matrix.q4, 'q4');
			this.flatten.q1 = this.getSubGroup(this.results.q1);
			this.flatten.q2 = this.getSubGroup(this.results.q2);
			this.flatten.q3 = this.getSubGroup(this.results.q3);
			this.flatten.q4 = this.getSubGroup(this.results.q4);
		},
		pushToArray(arr, model) {
			if (arr || arr.length > 0 || arr != undefined) {
				arr.forEach((y) => {
					this.results[model].push(y);
				});
			}
		},
		getSubGroup(group) {
			let items = [];
			let distribution = group.reduce(
				(acum, cur) =>
					// Object.assign(acum, {
					//   [`<h4>${cur.title}</h4><p>${cur.description}<br>(Cost ${cur.score})</p>`]:
					//     (acum[
					//       `<h4>${cur.title}</h4><p>${cur.description}<br>(Cost ${cur.score})</p>`
					//     ] |
					//       0) +
					//     1,
					// }),
					Object.assign(acum, {
						[`<h4>${cur.title}</h4>`]: (acum[`<h4>${cur.title}</h4>`] | 0) + 1,
					}),
				{}
			);
			for (var element in distribution) {
				items.push({ el: element, count: distribution[element] });
			}
			return items;
		},
	},
};
</script>
